import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import type { UgoConfig } from '@/api/types';
import { REDACTION_SENTINEL } from '@/api/types';
import { Field, FormShell, SecretInput } from './shared';

interface Props {
  initial: UgoConfig | null;
  onSubmit: (config: Partial<UgoConfig>) => void;
  submitting: boolean;
  onCancel: () => void;
  onReset?: () => void;
}

export function UgoForm({ initial, onSubmit, submitting, onCancel, onReset }: Props): JSX.Element {
  const { t } = useTranslation();
  const [baseUrl, setBaseUrl] = React.useState(initial?.baseUrl ?? 'https://www.upelgo.com');
  const [apiKey, setApiKey] = React.useState(initial?.apiKey ?? '');

  return (
    <form
      id="integration-form"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit({
          baseUrl: baseUrl.trim(),
          apiKey: apiKey === REDACTION_SENTINEL || !apiKey ? REDACTION_SENTINEL : apiKey,
        });
      }}
    >
      <FormShell submitting={submitting} onCancel={onCancel} onReset={onReset}>
        <Field label={t('integrations.form.ugo.baseUrl')} htmlFor="ugo-url" required>
          <Input
            id="ugo-url"
            value={baseUrl}
            onChange={(e) => setBaseUrl(e.target.value)}
            required
          />
        </Field>
        <Field
          label={t('integrations.form.ugo.apiKey')}
          htmlFor="ugo-key"
          required
          hint={t('integrations.form.ugo.apiKeyHint')}
        >
          <SecretInput id="ugo-key" value={apiKey} onChange={setApiKey} />
        </Field>
      </FormShell>
    </form>
  );
}
